<template>
  <div class="mt-4 mb-4">
    <form
      class="form document-form"
      @submit.prevent="sendDocumentsForm()"
      ref="form"
    >
      <div v-if="personType === 1">
        <form-group
          v-model="formModel"
          :fields="fields.personal.idCard[idCardType - 1]"
        />
        <form-group v-model="formModel" :fields="fields.personal.scan" />
      </div>
      <div v-if="personType === 2">
        <form-group v-model="formModel" :fields="fields.company" />
      </div>
      <div v-if="personType === 3">
        <form-group v-model="formModel" :fields="fields.child" />
      </div>

      <br /><br />
      <div class="form-field justify-content-left">
        <input
          v-model="formModel.gdpr"
          type="checkbox"
          name="gdpr"
          class="mt-2 mt-md-1 mr-2"
          required
        />
        <label for="gdpr"
          >{{ $t("i_agree") }}
          <a id="gdpr" name="gdpr" :href="$t('link_gdpr')" target="_blank">{{
            $t("to_gdpr")
          }}</a></label
        >
      </div>
      <input ref="submit" type="submit" hidden />
    </form>
  </div>
</template>

<script>
import FormGroup from "@/components/form/FormGroup";

export default {
  name: "DocumentsForm",
  components: {
    FormGroup
  },
  mounted() {
    this.$store.dispatch("onboarding/getPersonalInfo");
  },
  computed: {
    idCardType() {
      const personalInfo = this.$store.state.onboarding.personalInfo;
      return personalInfo ? personalInfo.idcard_type_id : 2;
    },
    personType() {
      const personalInfo = this.$store.state.onboarding.personalInfo;
      return personalInfo ? personalInfo.person_type_id : 1;
    }
  },
  data() {
    return {
      formModel: {
        doc1_front: {
          file: [],
          hex: ""
        },
        doc1_back: {
          file: [],
          hex: ""
        },
        doc2_front: {
          file: [],
          hex: ""
        },
        gdpr: false
      },
      fields: {
        personal: {
          idCard: [
            [
              {
                label: this.$t("passport_label"),
                placeholder: this.$t("passport_placeholder"),
                type: "file",
                model: "doc1_front",
                formWrapperClass: "col-md-12",
                accept: "image/jpeg, image/png, .pdf",
                required: false
              }
            ],
            [
              {
                label: this.$t("id_card_label"),
                placeholder: this.$t("id_card_front_placeholder"),
                type: "file",
                model: "doc1_front",
                formWrapperClass: "col-md-12",
                accept: "image/jpeg, image/png, .pdf",
                required: false
              },
              {
                placeholder: this.$t("id_card_back_placeholder"),
                type: "file",
                model: "doc1_back",
                formWrapperClass: "col-md-12",
                accept: "image/jpeg, image/png, .pdf",
                required: false
              }
            ]
          ],
          scan: [
            {
              label: this.$t("bank_account_statement_label"),
              placeholder: this.$t("bank_account_statement_placeholder"),
              type: "file",
              model: "doc2_front",
              formWrapperClass: "col-md-12",
              accept: "image/jpeg, image/png, .pdf",
              required: false
            }
          ]
        },
        company: [
          {
            label: this.$t("company_manager_id_card_label"),
            placeholder: this.$t("id_card_front_placeholder"),
            type: "file",
            model: "doc1_front",
            formWrapperClass: "col-md-12",
            accept: "image/jpeg, image/png, .pdf",
            required: false
          },
          {
            placeholder: this.$t("id_card_back_placeholder"),
            type: "file",
            model: "doc1_back",
            formWrapperClass: "col-md-12",
            accept: "image/jpeg, image/png, .pdf",
            required: false
          },
          {
            label: this.$t("company_bank_account_statement_label"),
            placeholder: this.$t("bank_account_statement_placeholder"),
            type: "file",
            model: "doc2_front",
            formWrapperClass: "col-md-12",
            accept: "image/jpeg, image/png, .pdf",
            required: false
          }
        ],
        child: [
          {
            label: this.$t("legal_representative_id_card_label"),
            placeholder: this.$t("id_card_front_placeholder"),
            type: "file",
            model: "doc1_front",
            formWrapperClass: "col-md-12",
            accept: "image/jpeg, image/png, .pdf",
            required: false
          },
          {
            placeholder: this.$t("id_card_back_placeholder"),
            type: "file",
            model: "doc1_back",
            formWrapperClass: "col-md-12",
            accept: "image/jpeg, image/png, .pdf",
            required: false
          },
          {
            label: this.$t("birth_certificate_of_child_label"),
            placeholder: this.$t("birth_certificate_of_child_placeholder"),
            type: "file",
            model: "doc2_front",
            formWrapperClass: "col-md-12",
            accept: "image/jpeg, image/png, .pdf",
            required: false
          }
        ]
      }
    };
  },
  methods: {
    submit() {
      this.$refs.submit.click();
      return this.$refs.form.checkValidity();
    },
    sendDocumentsForm() {
      this.$parent.$parent.loading = true;
      this.$store
        .dispatch("onboarding/saveDocuments", this.formModel)
        .then(() => {
          // this.$store.dispatch("onboarding/sendSummaryEmail");
          this.$parent.$parent.loading = false;
          this.$parent.$parent.nextStep();
        })
        .catch(() => {
          this.$parent.$parent.loading = false;
        });
    }
    // readFile: function(item, ev) {
    //   const file = ev.target.files[0];
    //   const reader = new FileReader();
    //   reader.readAsArrayBuffer(file);
    //   reader.onloadend = e => {
    //     const arrayBuffer = e.target.result;
    //     item.hex = Array.prototype.map
    //       .call(new Uint8Array(arrayBuffer), x =>
    //         ("00" + x.toString(16)).slice(-2)
    //       )
    //       .join("");
    //   };
    // }
  }
};
</script>
